import restArguments from "./restArguments.js";
import difference from "./difference.js";
export default restArguments(function(array, otherArrays) {
  return difference(array, otherArrays);
});
